import { useTagsForNote } from "@gbougakov/brief-ts/react";

interface TagChipsProps {
  noteId: string;
}

export function TagChips({ noteId }: TagChipsProps) {
  const tags = useTagsForNote(noteId);

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-surface-container-highest text-on-surface-variant text-xs"
        >
          <span>{tag.icon}</span>
          <span>{tag.label}</span>
        </span>
      ))}
    </div>
  );
}
